<ppg-image [url]="url" [width]="width" [height]="height" />
